// removed by extract-text-webpack-plugin
module.exports = {"verification":"forgotPassword_verification_3RsUe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forgotPassword/forgotPassword.scss
// module id = 1550
// module chunks = 0